import { render, staticRenderFns } from "./AppliedProjects.vue?vue&type=template&id=6f0745c6"
import script from "./AppliedProjects.vue?vue&type=script&lang=js"
export * from "./AppliedProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports